import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
// import "./App.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { createStore } from "redux";
import { Provider } from "react-redux";
import { loadState, saveState } from "./localStorage";
import store, { Persistor } from "./redux/store";
import { PersistGate } from "redux-persist/es/integration/react";
import "react-toastify/dist/ReactToastify.css";
import { HelmetProvider } from "react-helmet-async";

const persistedState = loadState();

// console.log = () => {};

store.subscribe(() => {
  saveState(store);
});

ReactDOM.render(
  <Provider store={store}>
    <PersistGate Loading={null} persistor={Persistor}>
      <HelmetProvider>
        <App />
      </HelmetProvider>
    </PersistGate>
  </Provider>,
  document.getElementById("root")
);

serviceWorker.register();
